@if (type === 'submit') {
  @if (!continue()) {
    <div class="modal-header d-flex align-items-center">
      <h2 class="modal-title" id="modal-basic-title">
        {{ 'security-policies-form-submit-title' | translate }} <b>{{ policy?.name }}</b>
      </h2>
      <button type="button" class="modal-close" aria-label="Close" (click)="sendclose('Cross click')"></button>
    </div>
    <div class="modal-body accept-modal">
      <div class="d-flex flex-column justify-content-around align-items-center">
        <h2>{{ 'security-policies-form-submit-sub-title-1' | translate }}</h2>
        <div ngbDropdown #Application="ngbDropdown">
          <button type="button" class="btn d-flex align-items-center" id="application" ngbDropdownAnchor (focus)="Application.open()">
            <p>{{ findAppli()?.packageName }}</p>
          </button>
          <div ngbDropdownMenu aria-labelledby="application">
            @for (app of lApplications(); track app) {
              <div>
                <button ngbDropdownItem (click)="selectedApp.set(app.id)">{{ app.packageName }}</button>
              </div>
            }
          </div>
        </div>
        <h4 class="alert">{{ 'security-policies-form-submit-alert-1' | translate }}</h4>
        <button class="btn btn-outline-primary d-flex flex-row justify-content-center continue"
          (click)="continue.set(true)">
          {{ 'continue' | translate }}
          <img class="side-arrow" src="assets/icons/ComprReport/down-arrow.svg">
        </button>
      </div>
    </div>
  }
  @if (continue()) {
    <div class="modal-header d-flex align-items-center">
      <button type="button" (click)="continue.set(false)" class="modal-back"></button>
      <h2 class="modal-title" id="modal-basic-title">
        {{ 'security-policies-form-submit-title' | translate }} <b>{{ policy?.name }}</b>
      </h2>
      <button type="button" class="modal-close" aria-label="Close" (click)="sendclose('Cross click')"></button>
    </div>
    <div class="modal-body accept-modal">
      <div class="d-flex flex-column justify-content-around align-items-center">
        <h2>
          {{ 'security-policies-form-submit-sub-title-2' | translate }} <b>{{ findAppli()?.packageName }}</b>
        </h2>
        @if (policy) {
          <div class="d-flex flex-row justify-content-around align-items-center policy">
            <div class="d-flex flex-column policnamebwv">
              <h4 class="elemTitre">{{ policy.name }}</h4>
              <h6>{{ policy.bwVersion?.version }}</h6>
            </div>
            <hr class="elemListehr">
            @if (policy.bwVersion) {
              <img class="os" src="assets/icons/logosOS/{{ policy.bwVersion.os.toLowerCase() }}.svg">
            }
            <div class="d-flex flex-column date">
              @if (policy.creationDate) {
                <h4 class="elemTitre text-center">
                  {{ 'security-policies-simulation-creation-date' | translate }}
                </h4>
                <div class="d-flex flex-column text-center">
                  <h5>{{ timestampToDate(policy.creationDate) }}</h5>
                  <h6>{{ horaire(policy.creationDate) }}</h6>
                </div>
              }
            </div>
          </div>
        }
        <div class="d-flex flex-row justify-content-center align-items-center">
          <img src="assets/icons/Settings/warning.svg">
          <h4 class="alert">{{ 'security-policies-form-submit-alert-2' | translate }}</h4>
        </div>
        <div class="d-flex flex-row justify-content-around">
          <button type="button" class="btn btn-outline-primary"
            (click)="sendclose('Cross click')">{{ 'cancel' | translate }}</button>
          <button type="button" class="btn btn-outline-success"
            (click)="emitClientAppID()">{{ 'confirm' | translate }}</button>
        </div>
      </div>
    </div>
  }
}

@if (type === 'accept') {
  <div class="modal-body accept-modal">
    <div class="d-flex flex-column align-items-center">
      <div class="d-flex flex-row head align-items-center justify-content-center">
        <h2>
          {{ 'security-policies-form-accept-title' | translate }} {{ policy?.name }}?
        </h2>
        <img type="button" placement="top"
          ngbTooltip="{{ 'security-policies-form-accept-tooltip' | translate }}"
          [closeDelay]="50000" src="assets/icons/info.svg">
      </div>
      @if (policy) {
        <div class="d-flex flex-row justify-content-around align-items-center policy">
          <div class="d-flex flex-column policnamebwv">
            <h4 class="elemTitre">{{ policy.name }}</h4>
            <h6>{{ policy.bwVersion?.version }}</h6>
          </div>
          <hr class="elemListehr">
          @if (policy.bwVersion) {
            <img class="os" src="assets/icons/logosOS/{{ policy.bwVersion.os.toLowerCase() }}.svg">
          }
          <div class="d-flex flex-column date">
            @if (policy.creationDate) {
              <h4 class="elemTitre text-center">
                {{ 'security-policies-simulation-creation-date' | translate }}
              </h4>
              <div class="d-flex flex-column text-center">
                <h5>{{ timestampToDate(policy.creationDate) }}</h5>
                <h6>{{ horaire(policy.creationDate) }}</h6>
              </div>
            }
          </div>
        </div>
      }
      <div class="d-flex flex-row justify-content-around">
        <button type="button" class="btn btn-outline-primary"
          (click)="sendclose('Cross click')">{{ 'cancel' | translate }}</button>
        <button type="button" class="btn btn-outline-success"
          (click)="send('activated')">{{ 'confirm' | translate }}</button>
      </div>
    </div>
  </div>
}

@if (type === 'refuse') {
  <div class="modal-body refuse-modal">
    <div class="d-flex flex-column align-items-center">
      <div class="d-flex flex-row head align-items-center justify-content-center">
        <h2>
          {{ 'security-policies-form-refuse-title' | translate }} {{ policy?.name }}?
        </h2>
        <img type="button" placement="top"
          ngbTooltip="{{ 'security-policies-form-refuse-tooltip' | translate }}"
          [closeDelay]="50000" src="assets/icons/info.svg">
      </div>
      @if (policy) {
        <div class="d-flex flex-row justify-content-around align-items-center policy">
          <div class="d-flex flex-column policnamebwv">
            <h4 class="elemTitre">{{ policy.name }}</h4>
            <h6>{{ policy.bwVersion?.version }}</h6>
          </div>
          <hr class="elemListehr">
          @if (policy.bwVersion) {
            <img class="os" src="assets/icons/logosOS/{{ policy.bwVersion.os.toLowerCase() }}.svg">
          }
          <div class="d-flex flex-column date">
            @if (policy.creationDate) {
              <h4 class="elemTitre text-center">
                {{ 'security-policies-simulation-creation-date' | translate }}
              </h4>
              <div class="d-flex flex-column text-center">
                <h5>{{ timestampToDate(policy.creationDate) }}</h5>
                <h6>{{ horaire(policy.creationDate) }}</h6>
              </div>
            }
          </div>
        </div>
      }
      <div class="d-flex flex-row justify-content-around">
        <button type="button" class="btn btn-outline-primary"
          (click)="sendclose('Cross click')">{{ 'cancel' | translate }}</button>
        <button type="button" class="btn btn-outline-success"
          (click)="send('refused')">{{ 'confirm' | translate }}</button>
      </div>
    </div>
  </div>
}
